import React, { useMemo } from 'react'
import { actionAtom } from 'atoms/atoms'
import { Provider, useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { ActionIds } from 'types/types'
import { AddNotificationForm } from '../AddNotificationForm'

interface IntegrationsSheetProps {
  isSheetOpen: boolean
}

export const IntegrationsSheet = ({ isSheetOpen }: IntegrationsSheetProps) => {
  const action = useAtomValue(actionAtom)
  const { onBack, onClose, header, subHeader } = action || {}

  const handleSheetClose = () => {
    onClose?.()
  }

  const sheetContent = useMemo(() => {
    switch (action?.actionId) {
      case ActionIds.HOOKS:
        return <AddNotificationForm handleClose={handleSheetClose} />
      default:
        return
    }
  }, [action?.actionId])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={handleSheetClose}
      subHeader={subHeader}
    >
      <Provider>{sheetContent}</Provider>
    </Sheet>
  )
}
